//------------------------------------------------------ externos
import Swal from "sweetalert2";
//------------------------------------------------------ funciones
import { createProveedor, updateProveedor } from "../../../services/cols/proveedores.service";
import { createPersona, updatePersona } from "../../../services/cols/personas.service";
import { createTractor, updateTractor } from "../../../services/cols/tractores.service";
import { createStock, updateStock } from "../../../services/cols/stock.service";
import { aplicarCambiosDeCodigos } from "../../../services/stockCodigos";
import { cambiosDeCodigos } from "../../../shared/stockEdicion";
import { updateDeposito } from "../../../services/cols/depositos.service";
import { createVehiculo, updateVehiculo } from "../../../services/cols/vehiculos.service";
import {
    verificarCamposObligatorios,
    formatearCampoFirestore, // desde el backend
    formatearCampoParaCarga,
    generarCodigoStock, // hacia el backend
} from "../../../functions/dataFunctions";
import {
    createFurgon,
    updateFurgon,
} from "../../../services/cols/furgones.service";
//import { getStock } from "../../../services/cols/stock.service";
import { realtime } from "../../../services/store";
import { guardarEvento, textoDeEventoNoGuardado } from "../../../functions/eventFunctions";
import { moverConEvento, textoDelMovimiento } from "../../../functions/movimientoConEvento";
import { deleteEvento } from "../../../services/cols/eventos.service";
import { sePuedeGuardar } from "./verificarDuplicados";
import { listarColeccion } from "../../../services/collections.service";
import {
    cuitDigitos,
    proveedoresConCuit,
    siguienteIdProveedor,
    textoCuitRepetido,
} from "../../../shared/proveedoresAlta";

/* El cartel de «se guardó», uno solo para los seis padrones.
 *
 * Nombra el elemento por el identificador con el que REALMENTE se guardó. Antes
 * cada alta leía `elementoAGuardar.id`, que sólo existe en personas (su campo
 * identificador se llama `id`): en tractores y furgones es `interno`, en
 * vehículos `dominio`, y el de stock se genera aparte. El cartel decía
 * «Elemento undefined». Al proveedor lo numera el alta (el siguiente libre, ver
 * `shared/proveedoresAlta`). Tampoco se nombra de dónde es el elemento: la
 * persona ya sabe qué estaba cargando. */
export const cartelDeGuardado = (id, hecho) => {
    const nombre = id === undefined || id === null || String(id).trim() === "" ? "" : ` ${id}`;
    return `Elemento${nombre} ${hecho} correctamente.`;
};

export const submitTractor = async (formData, campos, loading, onGuardar, onClose, modoEdicion = false, idElemento = null) => {
    const verificacion = verificarCamposObligatorios(campos, formData);
    if (!verificacion) return;

    // Lo que ya está cargado se avisa ANTES de escribir. El id corta;
    // la patente avisa y decide la persona. Ver `verificarDuplicados`.
    const idNuevo = campos.find((cp) => cp.isId)?.key;
    if (!(await sePuedeGuardar({ coleccion: "tractores", formData,
                                 idNuevo: idNuevo ? formData[idNuevo] : null,
                                 modoEdicion, idActual: idElemento }))) return;

    loading(true); // ahora si empieza a cargar ...

    let campoId;

    const elementoAGuardar = campos.reduce((acc, cp) => {
        if (cp.use !== "database") return acc; // solo se guardan los campos que tengan el "use" = "database" en elementos["tractores"]
        if (cp.isId) campoId = formData[cp.key];

        // let valor = formData[cp.key];
        let valor = formatearCampoParaCarga(formData[cp.key], cp.dato);

        acc[cp.key] = valor;
        return acc;
    }, {});

    // guardar elemento
    try {
        if (modoEdicion) {
            await updateTractor(idElemento, {
                ...elementoAGuardar,
                ultimaModificacion: formatearCampoFirestore(new Date()),
            });

            Swal.fire(
                "Actualizado",
                cartelDeGuardado(idElemento, "actualizado"),
                "success",
            );
        } else {
            const result = await Swal.fire({
                title: "Confirmar carga",
                html: `
            <pre style="text-align:left; max-height:300px; overflow:auto;">
            ${JSON.stringify({ id: campoId, ...elementoAGuardar }, null, 2)}
                </pre>
    `,
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Guardar",
                cancelButtonText: "Cancelar",
                confirmButtonColor: "#4161bd",
            });

            if (!result.isConfirmed) {
                loading(false);
                return;
            }
            await createTractor({
                id: campoId,
                ...elementoAGuardar,
            });

            Swal.fire(
                "Carga correcta",
                cartelDeGuardado(campoId, "creado"),
                "success",
            );

        }
        /* `onGuardar` SE LLAMA TAMBIÉN AL EDITAR, no sólo al dar de alta.
         *
         * La ficha del padrón edita adentro de sí misma y dibuja la fila que
         * recibió al abrirse: con `onGuardar` cierra (y la lista de atrás ya
         * trae lo nuevo), con `onClose` vuelve a la vista de lectura. Avisando
         * sólo `onClose`, después de guardar volvía a lectura mostrando los
         * valores de antes — la peor forma de contestar «se guardó». Vale
         * igual para los seis padrones de este archivo. */
        if (onGuardar) await onGuardar();
        //refreshCache("tractores"); // verificar funcionamiento!!
        onClose();
    } catch (error) {
        console.error("[Error] al intentar guardar", error);

        Swal.fire({
            title: "Error",
            text: "No hemos podido procesar la solicitud.",
            icon: "error",
            confirmButtonText: "Entendido",
            confirmButtonColor: "#4161bd",
        });
    } finally {
        loading(false);
    }
}
export const submitFurgon = async (formData, campos, loading, onGuardar, onClose, modoEdicion = false, idElemento = null) => {
    const verificacion = verificarCamposObligatorios(campos, formData);
    if (!verificacion) return;

    // Lo que ya está cargado se avisa ANTES de escribir. El id corta;
    // la patente avisa y decide la persona. Ver `verificarDuplicados`.
    const idNuevo = campos.find((cp) => cp.isId)?.key;
    if (!(await sePuedeGuardar({ coleccion: "furgones", formData,
                                 idNuevo: idNuevo ? formData[idNuevo] : null,
                                 modoEdicion, idActual: idElemento }))) return;

    loading(true); // ahora si empieza a cargar ...

    let campoId;

    const elementoAGuardar = campos.reduce((acc, cp) => {
        if (cp.use !== "database") return acc; // solo se guardan los campos que tengan el "use" = "database" en elementos["tractores"]
        if (cp.isId) campoId = formData[cp.key];

        // let valor = formData[cp.key];
        let valor = formatearCampoParaCarga(formData[cp.key], cp.dato);

        acc[cp.key] = valor;
        return acc;
    }, {});

    // guardar elemento
    try {
        if (modoEdicion) {
            await updateFurgon(idElemento, {
                ...elementoAGuardar,
                ultimaModificacion: formatearCampoFirestore(new Date()),
            });

            Swal.fire(
                "Actualizado",
                cartelDeGuardado(idElemento, "actualizado"),
                "success",
            );
        } else {
            const result = await Swal.fire({
                title: "Confirmar carga",
                html: `
            <pre style="text-align:left; max-height:300px; overflow:auto;">
            ${JSON.stringify({ id: campoId, ...elementoAGuardar }, null, 2)}
                </pre>
    `,
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Guardar",
                cancelButtonText: "Cancelar",
                confirmButtonColor: "#4161bd",
            });

            if (!result.isConfirmed) {
                loading(false);
                return;
            }
            await createFurgon({
                id: campoId,
                ...elementoAGuardar,
            });

            Swal.fire(
                "Carga correcta",
                cartelDeGuardado(campoId, "creado"),
                "success",
            );

        }
        // También al editar: ver la nota en `submitTractor`.
        if (onGuardar) await onGuardar();
        //refreshCache("furgones"); // verificar funcionamiento!!
        onClose();
    } catch (error) {
        console.error("[Error] al intentar guardar", error);

        Swal.fire({
            title: "Error",
            text: "No hemos podido procesar la solicitud.",
            icon: "error",
            confirmButtonText: "Entendido",
            confirmButtonColor: "#4161bd",
        });
    } finally {
        loading(false);
    }
}
export const submitVehiculo = async (formData, campos, loading, onGuardar, onClose, modoEdicion = false, idElemento = null) => {
    const verificacion = verificarCamposObligatorios(campos, formData);
    if (!verificacion) return;

    // Lo que ya está cargado se avisa ANTES de escribir. El id corta;
    // la patente avisa y decide la persona. Ver `verificarDuplicados`.
    const idNuevo = campos.find((cp) => cp.isId)?.key;
    if (!(await sePuedeGuardar({ coleccion: "vehiculos", formData,
                                 idNuevo: idNuevo ? formData[idNuevo] : null,
                                 modoEdicion, idActual: idElemento }))) return;

    loading(true); // ahora si empieza a cargar ...

    let campoId;

    const elementoAGuardar = campos.reduce((acc, cp) => {
        if (cp.use !== "database") return acc; // solo se guardan los campos que tengan el "use" = "database" en elementos["tractores"]
        if (cp.isId) campoId = formData[cp.key];

        // let valor = formData[cp.key];
        let valor = formatearCampoParaCarga(formData[cp.key], cp.dato);

        acc[cp.key] = valor;
        return acc;
    }, {});

    // guardar elemento
    try {
        if (modoEdicion) {
            await updateVehiculo(idElemento, {
                ...elementoAGuardar,
                ultimaModificacion: formatearCampoFirestore(new Date()),
            });

            Swal.fire(
                "Actualizado",
                cartelDeGuardado(idElemento, "actualizado"),
                "success",
            );
        } else {
            const result = await Swal.fire({
                title: "Confirmar carga",
                html: `
            <pre style="text-align:left; max-height:300px; overflow:auto;">
            ${JSON.stringify({ id: campoId, ...elementoAGuardar }, null, 2)}
                </pre>
    `,
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Guardar",
                cancelButtonText: "Cancelar",
                confirmButtonColor: "#4161bd",
            });

            if (!result.isConfirmed) {
                loading(false);
                return;
            }
            await createVehiculo({
                id: campoId,
                ...elementoAGuardar,
            });

            Swal.fire(
                "Carga correcta",
                cartelDeGuardado(campoId, "creado"),
                "success",
            );

        }
        // También al editar: ver la nota en `submitTractor`.
        if (onGuardar) await onGuardar();
        //refreshCache("vehiculos"); // verificar funcionamiento!!
        onClose();
    } catch (error) {
        console.error("[Error] al intentar guardar", error);

        Swal.fire({
            title: "Error",
            text: "No hemos podido procesar la solicitud.",
            icon: "error",
            confirmButtonText: "Entendido",
            confirmButtonColor: "#4161bd",
        });
    } finally {
        loading(false);
    }
}
export const submitPersona = async (formData, campos, loading, onGuardar, onClose, modoEdicion = false, idElemento = null) => {
    const verificacion = verificarCamposObligatorios(campos, formData);
    if (!verificacion) return;

    // Lo que ya está cargado se avisa ANTES de escribir. El id corta;
    // la patente avisa y decide la persona. Ver `verificarDuplicados`.
    const idNuevo = campos.find((cp) => cp.isId)?.key;
    if (!(await sePuedeGuardar({ coleccion: "personas", formData,
                                 idNuevo: idNuevo ? formData[idNuevo] : null,
                                 modoEdicion, idActual: idElemento }))) return;

    loading(true); // ahora si empieza a cargar ...

    let campoId;

    const elementoAGuardar = campos.reduce((acc, cp) => {
        if (cp.use !== "database") return acc; // solo se guardan los campos que tengan el "use" = "database" en elementos["tractores"]
        if (cp.isId) campoId = formData[cp.key];

        // let valor = formData[cp.key];
        let valor = formatearCampoParaCarga(formData[cp.key], cp.dato);

        acc[cp.key] = valor;
        return acc;
    }, {});

    // guardar elemento
    try {
        if (modoEdicion) {
            await updatePersona(idElemento, {
                ...elementoAGuardar,
                ultimaModificacion: formatearCampoFirestore(new Date()),
            });

            Swal.fire(
                "Actualizado",
                cartelDeGuardado(idElemento, "actualizado"),
                "success",
            );
        } else {
            const result = await Swal.fire({
                title: "Confirmar carga",
                html: `
            <pre style="text-align:left; max-height:300px; overflow:auto;">
            ${JSON.stringify({ id: campoId, ...elementoAGuardar }, null, 2)}
                </pre>
    `,
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Guardar",
                cancelButtonText: "Cancelar",
                confirmButtonColor: "#4161bd",
            });

            if (!result.isConfirmed) {
                loading(false);
                return;
            }
            /* EL ALTA NACE ACTIVA Y CON SU DNI (ticket 317, Nico 06/10: «me
               está faltando… empleado nuevo de taller»). El formulario guarda
               el DNI como `id`, y las columnas `dni` y `estado` —que el padrón
               que vino de CantApp trae cargadas— quedaban vacías. Todo lo que
               busca gente pide `estado = "true"`: herramientas, el buscador,
               los avisos. La persona existía y no aparecía en ningún lado, y
               en el buscador figuraba como dada de baja. Tres altas de RRHH
               de septiembre estaban así.

               Sólo al CREAR: una edición no puede reactivar a quien se dio de
               baja ni tocarle el estado. */
            await createPersona({
                id: campoId,
                ...elementoAGuardar,
                dni: String(campoId),
                estado: "true",
            });

            Swal.fire(
                "Carga correcta",
                cartelDeGuardado(campoId, "creado"),
                "success",
            );

        }
        // También al editar: ver la nota en `submitTractor`.
        if (onGuardar) await onGuardar();
        //refreshCache("personas"); // verificar funcionamiento!!
        onClose();
    } catch (error) {
        console.error("[Error] al intentar guardar", error);

        Swal.fire({
            title: "Error",
            text: "No hemos podido procesar la solicitud.",
            icon: "error",
            confirmButtonText: "Entendido",
            confirmButtonColor: "#4161bd",
        });
    } finally {
        loading(false);
    }
}
export const submitProveedor = async (formData, campos, loading, onGuardar, onClose, modoEdicion = false, idElemento = null) => {
    const verificacion = verificarCamposObligatorios(campos, formData);
    if (!verificacion) return;

    loading(true); // ahora si empieza a cargar ...

    let campoId;

    const elementoAGuardar = campos.reduce((acc, cp) => {
        if (cp.use !== "database") return acc; // solo se guardan los campos que tengan el "use" = "database" en elementos["tractores"]
        if (cp.isId) campoId = formData[cp.key];

        // let valor = formData[cp.key];
        let valor = formatearCampoParaCarga(formData[cp.key], cp.dato);

        acc[cp.key] = valor;
        return acc;
    }, {});

    // guardar elemento
    try {
        if (modoEdicion) {
            await updateProveedor(idElemento, {
                ...elementoAGuardar,
                ultimaModificacion: formatearCampoFirestore(new Date()),
            });

            Swal.fire(
                "Actualizado",
                cartelDeGuardado(idElemento, "actualizado"),
                "success",
            );
        } else {
            /* EL NÚMERO LO PONE EL ALTA: `proveedores.id` es obligatorio y la
             * base no lo numera. Sin esto, todo proveedor nuevo rebotaba con
             * «No hemos podido procesar la solicitud» (Nico, 20/10, con
             * Wurth). Ver `shared/proveedoresAlta`. */
            let filas;
            try {
                filas = await listarColeccion("proveedores");
            } catch (e) {
                console.error("[proveedores] no pude leer los cargados:", e);
                Swal.fire({
                    title: "No se pudo guardar",
                    text: "No pude leer los proveedores cargados para darle número al nuevo. Probá de nuevo en un rato.",
                    icon: "error",
                    confirmButtonText: "Entendido",
                    confirmButtonColor: "#4161bd",
                });
                return;
            }
            // El CUIT, con sus dígitos: así están los demás, y con guiones se perdía.
            const cuit = cuitDigitos(formData.cuit);
            elementoAGuardar.cuit = cuit || null;
            const ya = proveedoresConCuit(filas, cuit);
            if (ya.length) {
                const r = await Swal.fire({
                    title: "Ese CUIT ya está cargado",
                    text: textoCuitRepetido(cuit, ya),
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Guardar igual",
                    cancelButtonText: "Revisar",
                    focusCancel: true,
                    confirmButtonColor: "#4161bd",
                });
                if (!r.isConfirmed) return;
            }
            campoId = siguienteIdProveedor(filas);

            const result = await Swal.fire({
                title: "Confirmar carga",
                html: `
            <pre style="text-align:left; max-height:300px; overflow:auto;">
            ${JSON.stringify({ id: campoId, ...elementoAGuardar }, null, 2)}
                </pre>
    `,
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Guardar",
                cancelButtonText: "Cancelar",
                confirmButtonColor: "#4161bd",
            });

            if (!result.isConfirmed) {
                loading(false);
                return;
            }
            try {
                await createProveedor({
                    id: campoId,
                    ...elementoAGuardar,
                });
            } catch (e) {
                /* Si otro cargó un proveedor en el medio, ese número ya no
                 * está libre (23505: clave repetida): se toma el siguiente y
                 * se prueba UNA vez más. */
                if (e?.code !== "23505") throw e;
                campoId = siguienteIdProveedor(await listarColeccion("proveedores"));
                await createProveedor({
                    id: campoId,
                    ...elementoAGuardar,
                });
            }

            Swal.fire(
                "Carga correcta",
                cartelDeGuardado(campoId, "creado"),
                "success",
            );

        }
        // También al editar: ver la nota en `submitTractor`.
        if (onGuardar) await onGuardar();
        //refreshCache("proveedores"); // verificar funcionamiento!!
        onClose();
    } catch (error) {
        console.error("[Error] al intentar guardar", error);

        Swal.fire({
            title: "Error",
            text: "No hemos podido procesar la solicitud.",
            icon: "error",
            confirmButtonText: "Entendido",
            confirmButtonColor: "#4161bd",
        });
    } finally {
        loading(false);
    }
}
/* `extra.codigos` = `{originales, actuales}`: los códigos de barras de la
 * edición (ver `CodigosDeBarras`). Se escriben DESPUÉS de la ficha y sólo la
 * diferencia; si alguno no entra, el cartel lo dice en vez de «Actualizado». */
export const submitStock = async (formData, campos, loading, onGuardar, onClose, modoEdicion = false, idElemento = null, extra = {}) => {
    const verificacion = verificarCamposObligatorios(campos, formData);
    if (!verificacion) return;

    loading(true); // ahora si empieza a cargar ...

    /* EL CÓDIGO SE ARMA SÓLO AL DAR DE ALTA. Editando, el id es el que ya
     * tiene (`idElemento`) y no se toca nunca: está en movimientos, depósitos
     * y en `stock_codigos`. Antes se calculaba igual al editar y se tiraba —
     * inofensivo, pero es la línea que el día que alguien la use para guardar
     * renumera un artículo por haberle corregido el tipo. */
    const idGenerado = modoEdicion
        ? null
        : await generarCodigoStock(formData.tipo, formData.proveedor);

    const elementoAGuardar = campos.reduce((acc, cp) => {
        if (cp.use !== "database") return acc; // solo se guardan los campos que tengan el "use" = "database" en elementos["tractores"]

        // let valor = formData[cp.key];
        let valor = formatearCampoParaCarga(formData[cp.key], cp.dato);

        acc[cp.key] = valor;
        return acc;
    }, {});

    // Lo que quedó guardado, para quien abrió el formulario (la página de
    // la sede lo usa para corregir el renglón sin recargar).
    let guardado = null;

    // guardar elemento
    try {
        if (modoEdicion) {
            await updateStock(idElemento, {
                ...elementoAGuardar,
                ultimaModificacion: formatearCampoFirestore(new Date()),
            });
            guardado = { id: idElemento, ...elementoAGuardar };

            const problemas = extra.codigos
                ? await aplicarCambiosDeCodigos(
                    idElemento,
                    cambiosDeCodigos(extra.codigos.originales, extra.codigos.actuales),
                )
                : [];

            if (problemas.length > 0) {
                Swal.fire({
                    title: "La ficha se guardó, los códigos no todos",
                    text: problemas.join(" "),
                    icon: "warning",
                    confirmButtonText: "Entendido",
                    confirmButtonColor: "#4161bd",
                });
            } else {
                Swal.fire(
                    "Actualizado",
                    cartelDeGuardado(idElemento, "actualizado"),
                    "success",
                );
            }
        } else {
            const result = await Swal.fire({
                title: "Confirmar carga",
                html: `
            <pre style="text-align:left; max-height:300px; overflow:auto;">
            ${JSON.stringify({ id: idGenerado, ...elementoAGuardar }, null, 2)}
                </pre>
    `,
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Guardar",
                cancelButtonText: "Cancelar",
                confirmButtonColor: "#4161bd",
            });

            if (!result.isConfirmed) {
                loading(false);
                return;
            }
            await createStock({
                id: idGenerado,
                ...elementoAGuardar,
            });
            guardado = { id: idGenerado, ...elementoAGuardar };

            Swal.fire(
                "Carga correcta",
                cartelDeGuardado(idGenerado, "creado"),
                "success",
            );

        }
        // También al editar: ver la nota en `submitTractor`.
        if (onGuardar) await onGuardar(guardado);
        //refreshCache("stock"); // verificar funcionamiento!!
        onClose();
    } catch (error) {
        console.error("[Error] al intentar guardar", error);

        Swal.fire({
            title: "Error",
            text: "No hemos podido procesar la solicitud.",
            icon: "error",
            confirmButtonText: "Entendido",
            confirmButtonColor: "#4161bd",
        });
    } finally {
        loading(false);
    }
}
/* El cartel de un movimiento de stock que no salió entero. Dice qué pasó:
 * «No se movió nada» si se deshizo todo, o el número del registro si quedó
 * algo escrito (`moverConEvento`). */
const avisarMovimientoFallido = (error) => {
    Swal.fire({
        title: error?.motivo === "parcial"
            ? "El movimiento quedó a medias"
            : "No se guardó el movimiento",
        text: textoDelMovimiento(error),
        icon: "error",
        confirmButtonColor: "#4161bd",
    });
};

const cartelDeCarga = (id) =>
    Swal.fire("Carga correcta", `Elemento ${id} creado correctamente.`, "success");

/* «Movimiento de stock»: el evento primero, después cada artículo y al final
 * el depósito. Si un paso falla se deshacen los anteriores y se borra el
 * evento (ver `moverConEvento`). Hasta el 21/10 el evento iba último, y si
 * fallaba el saldo ya se había movido. */
export const submitMovimientoStock = async (elemento, formData, campos, setLoading, onGuardar, onClose) => {
    setLoading(true);

    try {
        const stock = realtime.stock || [];
        const stockMap = Object.fromEntries(stock.map(st => [st.id, st]));
        const movimientos = formData.ingresos || [];

        const pasos = [];

        for (const itemForm of movimientos) {
            const itemStock = stockMap[itemForm.id];

            if (!itemStock) continue;

            const antes = itemStock.cantidad;
            const cant = Number(itemStock.cantidad || 0) + Number(itemForm.cantidad || 0);

            /* HASTA NO TENER ACEITADO TODO NO ACTIVAR VERIFICACIÓN DE NEGATIVOS
            if(cant < 1){
                console.error(`[Stock] Insuficiente para ${itemStock.id} (${itemStock.descripcion})`);
                continue;
            }
            */

            pasos.push({
                hacer: () => updateStock(itemStock.id, { cantidad: cant }),
                deshacer: () => updateStock(itemStock.id, { cantidad: antes }),
            });
        }

        const deposito = (realtime.depositos || []).find((dp) => String(dp.id) === String(formData.deposito));

        if (deposito) {
            // Copia por renglón: sumar sobre la fila de `realtime` cambiaba lo
            // que muestra la pantalla aunque después no se guardara nada.
            const original = deposito.stock || [];
            const stockDepo = original.map((ar) => ({ ...ar }));

            for (const mv of movimientos) {
                const itemDepo = stockDepo.find((ar) => String(ar.id) === String(mv.id));

                if (itemDepo) {
                    itemDepo.cantidad = Number(itemDepo.cantidad || 0) + Number(mv.cantidad);
                } else {
                    stockDepo.push({
                        id: mv.id,
                        cantidad: Number(mv.cantidad),
                        unidad: mv.unidad || "",
                    });
                }
            }

            pasos.push({
                hacer: () => updateDeposito(deposito.id, { stock: limpiarStock(stockDepo) }),
                deshacer: () => updateDeposito(deposito.id, { stock: limpiarStock(original) }),
            });
        }

        const { id } = await moverConEvento({
            registrar: () => guardarEvento(
                elemento,
                {
                    tipo: "STOCK",
                    area: formData.area || "administracion",
                    deposito: formData.deposito || "",
                    detalle: formData.detalle || "",
                    movimientos: formData.ingresos || [],
                },
                formData,
                campos,
                "administracion",
                false,
                false,
                null,
                { avisar: false }
            ),
            pasos,
            borrarEvento: deleteEvento,
        });

        cartelDeCarga(id);
        onGuardar?.();
        onClose?.();
    } catch (error) {
        console.error(`[Error] Al actualizar el stock: `, error);
        avisarMovimientoFallido(error);
    } finally {
        setLoading(false);
    }


}
/* «Movimiento entre depósitos»: el evento primero, después el origen y el
 * destino, con la misma vuelta atrás que el de stock. */
export const submitMovimientoStockDepositos = async (
    elemento,
    formData,
    campos,
    setLoading,
    onGuardar,
    onClose
) => {
    setLoading(true);

    try {

        if (formData.origen === formData.destino) {
            Swal.fire({
                title: "Movimiento inválido",
                text: "El depósito origen y destino no pueden ser iguales.",
                icon: "warning",
                confirmButtonColor: "#4161bd",
            });

            return;
        }

        const depositos = realtime.depositos || [];

        const origen = depositos.find(
            d => String(d.id) === String(formData.origen)
        );

        const destino = depositos.find(
            d => String(d.id) === String(formData.destino)
        );

        if (!origen) {
            throw new Error("Depósito origen inexistente");
        }

        if (!destino) {
            throw new Error("Depósito destino inexistente");
        }

        // Copias por renglón: lo de `realtime` queda como estaba hasta que
        // la base confirme, y es lo que se devuelve si hay que deshacer.
        const stockOrigen = (origen.stock || []).map((ar) => ({ ...ar }));
        const stockDestino = (destino.stock || []).map((ar) => ({ ...ar }));

        const movimientos = formData.ingresos || [];

        for (const mov of movimientos) {

            const itemOrigen = stockOrigen.find(
                art => String(art.id) === String(mov.id)
            );

            if (!itemOrigen) {

                Swal.fire({
                    title: "Artículo inexistente",
                    text: `El artículo ${mov.id} no existe en el depósito ${origen.id}.`,
                    icon: "error",
                    confirmButtonColor: "#4161bd",
                });

                return;
            }

            const cantidad = Number(mov.cantidad);

            if (Number(itemOrigen.cantidad) < cantidad) {

                Swal.fire({
                    title: "Stock insuficiente",
                    text: `${itemOrigen.descripcion || mov.id} posee ${itemOrigen.cantidad} unidades en ${origen.id}.`,
                    icon: "warning",
                    confirmButtonColor: "#4161bd",
                });

                return;
            }

            // Restar origen
            itemOrigen.cantidad = Number(itemOrigen.cantidad) - cantidad;

            // Buscar en destino
            let itemDestino = stockDestino.find(
                art => String(art.id) === String(mov.id)
            );

            if (itemDestino) {

                itemDestino.cantidad = Number(itemDestino.cantidad || 0) + cantidad;

            } else {

                stockDestino.push({
                    id: mov.id,
                    cantidad,
                    unidad: itemOrigen.unidad,
                });

            }
        }

        const { id } = await moverConEvento({
            registrar: () => guardarEvento(
                elemento,
                {
                    tipo: "MOVIMIENTO INTERNO",
                    area: formData.area || "administracion", // el codigo del evento se crea con el area, NO SACAR
                    origen: origen.id,
                    destino: destino.id,

                    detalle: formData.detalle || "",
                    movimientos,
                },
                formData,
                campos,
                "administracion",
                false,
                false,
                null,
                { avisar: false }
            ),
            pasos: [
                {
                    hacer: () => updateDeposito(origen.id, { stock: limpiarStock(stockOrigen) }),
                    deshacer: () => updateDeposito(origen.id, { stock: limpiarStock(origen.stock || []) }),
                },
                {
                    hacer: () => updateDeposito(destino.id, { stock: limpiarStock(stockDestino) }),
                    deshacer: () => updateDeposito(destino.id, { stock: limpiarStock(destino.stock || []) }),
                },
            ],
            borrarEvento: deleteEvento,
        });

        cartelDeCarga(id);
        onGuardar?.();
        onClose?.();

    } catch (error) {

        console.error(
            "[Error] Al mover stock entre depósitos:",
            error
        );

        if (error?.motivo) {
            avisarMovimientoFallido(error);
        } else {
            Swal.fire({
                title: "Error",
                text: error.message,
                icon: "error",
                confirmButtonColor: "#4161bd",
            });
        }

    } finally {

        setLoading(false);

    }
};
/* Portería, Llaves y Tráfico: si el evento no se guardó, se dice. Hasta el
 * 21/10 el error iba sólo a la consola: entre el 14/10 y el 20/10 fallaron 106
 * cargas de portería y el guardia no vio nada — la ventana quedaba abierta y
 * volvía a tocar Guardar. */
const avisarEventoNoGuardado = (titulo, error) => {
    Swal.fire({
        title: titulo,
        text: textoDeEventoNoGuardado(error),
        icon: "error",
        confirmButtonColor: "#4161bd",
    });
};
export const submitMovimientoPorteria = async (elemento, formData, campos, setLoading, onGuardar, onClose) => {
    setLoading(true);

    try {
        await guardarEvento(
            elemento,
            {
                area: "porteria",
                tipo: formData.tipo || null,
                operador: formData.operador || null,
                persona: formData.persona || null,
                tractor: formData.tractor || null,
                furgon: formData.furgon || null,
                cargado: formData.cargado || false,
                detalle: formData.detalle || null,
                chequeos: formData.chequeos || [],
            },
            formData,
            campos,
            "porteria",
            false
        );

        onGuardar?.();
        onClose?.();
    } catch (error) {
        console.error(`[Error] Al guardar evento de portería: `, error);
        avisarEventoNoGuardado("No se guardó el movimiento de portería", error);
    } finally {
        setLoading(false);
    }
};
export const submitMovimientoLlaves = async (elemento, formData, campos, setLoading, onGuardar, onClose) => {
    setLoading(true);

    try {
        await guardarEvento(
            elemento,
            {
                area: "porteria",
                tipo: formData.tipo || null,
                operador: formData.operador || null,
                persona: formData.persona || null,
                tractor: formData.tractor || [],
                detalle: formData.detalle || null,
            },
            formData,
            campos,
            formData.area || "porteria",
            false
        );

        onGuardar?.();
        onClose?.();
    } catch (error) {
        console.error(`[Error] Al guardar evento de llaves: `, error);
        avisarEventoNoGuardado("No se guardó el movimiento de llaves", error);
    } finally {
        setLoading(false);
    }
};
export const submitMovimientoTrafico = async (elemento, formData, campos, setLoading, onGuardar, onClose, satelital = false) => {
    setLoading(true);

    try {
        await guardarEvento(
            elemento,
            {
                area: satelital ? "satelital" : "trafico",
                tipo: formData.tipo || null,
                operador: formData.operador || null,
                persona: formData.persona || null,
                tractor: formData.tractor || null,
                furgon: formData.furgon || null,
                detalle: formData.detalle || null,
            },
            formData,
            campos,
            "trafico",
            false
        );

        onGuardar?.();
        onClose?.();
    } catch (error) {
        console.error(`[Error] Al guardar evento de trafico: `, error);
        avisarEventoNoGuardado("No se guardó el movimiento", error);
    } finally {
        setLoading(false);
    }
};
export const submitMovimientoAsignacion = async (elemento, formData, campos, setLoading, onGuardar, onClose, usuario = null) => {
    setLoading(true);

    try {
        await guardarEvento(
            elemento,
            {
                //articulo: formData.articulo || null,  
                //cantidad: formData.cantidad || null,
                ingresos: formData.ingresos || [], // reemplaza articulo y cantidad
                detalle: formData.detalle || null,
                persona: formData.persona || null,
                area: formData.area || null,
            },
            formData,
            campos,
            "asignaciones",
            false, // modoEdicion
            true, // asignacion
            usuario
        );

        onGuardar?.();
        onClose?.();
    } catch (error) {
        console.error(`[Error] Al guardar asignacion de herramienta: `, error);
        avisarEventoNoGuardado("No se guardó la asignación", error);
    } finally {
        setLoading(false);
    }
}

// helpers

export const limpiarStock = (stock) =>
    stock.map(({ id, cantidad, unidad }) => ({
        id,
        cantidad,
        unidad,
    }));